import { Flex, Text } from '@chakra-ui/react';
import { ButtonComponent } from 'components/buttons/ButtonComponent';
import { useGlobalContext } from 'contexts/GlobalContext';
import { useHistory } from 'react-router-dom';

export default function PageNotFound() {
	const history = useHistory();
	const { pathCompanyName } = useGlobalContext();

	return (
		<Flex
			direction='column'
			align='center'
			justify='center'
			h='100vh'
		>
			<Text
				fontSize='160px'
				fontWeight='600'
				color={'easyBLUE.300'}
			>
				404
			</Text>
			<Text
				fontSize='20px'
				fontWeight='600'
				color={'easyBLUE.300'}
			>
				Erro, página não encontrada
			</Text>
			<ButtonComponent
				marginTop='5vh'
				type={'primary'}
				title={'Voltar para a página inicial'}
				onClick={() => history.push(`/${pathCompanyName}`)}
			/>
		</Flex>
	);
}
